class ShoppableFeaturedHomes extends HTMLElement {
  constructor() {
    super();
    this.sectionId = null;
    this.sectionEl = null;
    this.galleryEl = null;
  }

  connectedCallback() {
    // Get section ID from the parent section element
    this.sectionEl = this.closest('[id^="shopify-section-"]');
    if (this.sectionEl) {
      this.sectionId = this.sectionEl.id.replace('shopify-section-', '');
    }

    // Initialize accordions
    this.initAccordions();

    // Initialize gallery modal
    this.initGalleryModal();
  }

  initAccordions() {
    const plusIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
        <path d="M14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H8.5V13.5C8.5 13.6326 8.44732 13.7598 8.35355 13.8536C8.25979 13.9473 8.13261 14 8 14C7.86739 14 7.74021 13.9473 7.64645 13.8536C7.55268 13.7598 7.5 13.6326 7.5 13.5V8.5H2.5C2.36739 8.5 2.24021 8.44732 2.14645 8.35355C2.05268 8.25979 2 8.13261 2 8C2 7.86739 2.05268 7.74021 2.14645 7.64645C2.24021 7.55268 2.36739 7.5 2.5 7.5H7.5V2.5C7.5 2.36739 7.55268 2.24021 7.64645 2.14645C7.74021 2.05268 7.86739 2 8 2C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5V7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8Z"/>
      </svg>
    `;

    const minusIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
        <path d="M14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H2.5C2.36739 8.5 2.24021 8.44732 2.14645 8.35355C2.05268 8.25979 2 8.13261 2 8C2 7.86739 2.05268 7.74021 2.14645 7.64645C2.24021 7.55268 2.36739 7.5 2.5 7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8Z"/>
      </svg>
    `;

    // Only get accordions within this component's scope
    const accordions = this.querySelectorAll('.showroom-hours');
    accordions.forEach((showroom) => {
      const header = showroom.querySelector('.accordion-header');
      const body = showroom.querySelector('.accordion-body');
      const iconContainer = header.querySelector('.accordion-icon');

      // Prevent duplicate event listeners
      if (header.dataset.listenerAdded === 'true') return;
      
      iconContainer.innerHTML = plusIcon;
      header.addEventListener('click', () => {
        header.classList.toggle('active');
        const isActive = header.classList.contains('active');
        iconContainer.innerHTML = isActive ? minusIcon : plusIcon;
        if (isActive) {
          body.style.maxHeight = body.scrollHeight + 'px';
        } else {
          body.style.maxHeight = '0px';
        }
      });
      header.dataset.listenerAdded = 'true';
    });
  }

  initGalleryModal() {
    if (!this.sectionId || !this.sectionEl) return;

    try {
      this.galleryEl = document.getElementById('Gallery-' + this.sectionId);
      
      if (!this.galleryEl) return;

      const openModal = () => {
        this.galleryEl.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };

      const closeModal = () => {
        this.galleryEl.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      // Listen for clicks on openGallery buttons within this section
      this.sectionEl.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-el="openGallery"]');
        if (openBtn && this.sectionEl.contains(openBtn)) {
          e.preventDefault();
          e.stopPropagation();
          openModal();
        }
      });

      // Listen for clicks on closeGallery button and backdrop within this gallery
      this.galleryEl.addEventListener('click', (e) => {
        const closeBtn = e.target.closest('[data-el="closeGallery"]');
        if (closeBtn) {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
          return;
        }

        // Close if clicking on the gallery backdrop (but not on child elements)
        if (e.target === this.galleryEl && this.galleryEl.getAttribute('aria-hidden') === 'false') {
          e.preventDefault();
          closeModal();
        }
      });

      // Escape key handler - scoped to this gallery
      const escapeHandler = (evt) => {
        if (evt.key === 'Escape' && this.galleryEl && this.galleryEl.getAttribute('aria-hidden') === 'false') {
          closeModal();
        }
      };
      document.addEventListener('keydown', escapeHandler);

      // Clean up escape handler when component is disconnected
      this.escapeHandler = escapeHandler;
    } catch (err) {
      console.error('Gallery modal error:', err);
    }
  }

  disconnectedCallback() {
    // Clean up event listeners if needed
    if (this.escapeHandler) {
      document.removeEventListener('keydown', this.escapeHandler);
    }
  }
}

customElements.define('shoppable-featured-homes', ShoppableFeaturedHomes);